import type { IMappers } from 'shared/repositories/cpd/v1/create-cpd-draft';

import type { ICreateCPDDraftResponseError, ICreateCPDDraftResponseSuccess } from '../types';
import { IV1CreateCpdDraftResponse } from 'shared/repositories/cpd/entities/v1_create_cpd_draft/V1CreateCpdDraftResponse';

export const map200Response = (response: IV1CreateCpdDraftResponse): ICreateCPDDraftResponseSuccess => {
  const { cpdDraftId } = response;

  return {
    isSuccess: true,
    cpdDraftId,
  };
};

export const map400Response = (): ICreateCPDDraftResponseError => {
  return {
    cpdDraftId: null,
    isSuccess: false,
  };
};

export const mappers: IMappers<ICreateCPDDraftResponseSuccess, ICreateCPDDraftResponseError> = {
  200: map200Response,
  400: map400Response,
};
